import styled from "styled-components";

export const Strong = styled.strong`
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;

  color: ${({ theme }) =>
    theme.checkoutStepsOffers?.widgetTextColor} !important;
`;

export const Paragraph = styled.p`
  margin: 1rem 0 0;
  padding-bottom: 1rem;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) =>
    theme.checkoutStepsOffers?.widgetTextColor} !important;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;
